export default __webpack_public_path__ + "static/media/Facebook-Normal.8c6601de.png";